import Notification from './Notification';
export default Notification;



// WEBPACK FOOTER //
// ./src/index.js